/**
 * TanStack Query hooks for `campaign-visibility-assigned-only-all-per-role`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignVisibilityAssignedOnlyAllPerRoleQueryKeys,
	type CreateCampaignVisibilityAssignedOnlyAllPerRoleBody,
	type ListCampaignVisibilityAssignedOnlyAllPerRoleResponse,
	type CampaignVisibilityAssignedOnlyAllPerRoleRow,
} from "./api";

export function useCampaignVisibilityAssignedOnlyAllPerRoleList(): UseQueryResult<ListCampaignVisibilityAssignedOnlyAllPerRoleResponse, Error> {
	return useQuery({
		queryKey: campaignVisibilityAssignedOnlyAllPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignVisibilityAssignedOnlyAllPerRoleCreate(): UseMutationResult<CampaignVisibilityAssignedOnlyAllPerRoleRow, Error, CreateCampaignVisibilityAssignedOnlyAllPerRoleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignVisibilityAssignedOnlyAllPerRoleQueryKeys.all });
		},
	});
}

export function useCampaignVisibilityAssignedOnlyAllPerRoleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignVisibilityAssignedOnlyAllPerRoleQueryKeys.all });
		},
	});
}
